import { env } from "@/env";
import * as Sentry from "@sentry/react";

const API_URL = env.API_URL;

// Only initialize Sentry in production
if (import.meta.env.VITE_SENTRY_DSN && import.meta.env.MODE === "production") {
  Sentry.init({
    enabled: import.meta.env.VITE_SENTRY_ENABLED === "true",
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,

    // Performance monitoring
    tracesSampleRate: Number.parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? "1.0"),

    // Browser-specific integrations
    integrations: [
      Sentry.browserTracingIntegration({
        // Track navigation and page loads
        enableInp: true,
        enableLongTask: true,
      }),
      // Session replay for debugging (optional)
      Sentry.replayIntegration(),
    ],

    // Session Replay configuration
    replaysSessionSampleRate: 0.1, // 10% of sessions
    replaysOnErrorSampleRate: 1.0, // 100% of error sessions

    // Widget-specific configuration
    beforeSend(event, hint) {
      // Don't capture host page information to respect privacy
      if (event.request) {
        delete event.request.url;
        delete event.request.headers;
      }

      // Add widget context
      event.tags = {
        ...event.tags,
        component: "ai-widget",
      };

      return event;
    },

    // Set trace propagation targets for widget API calls
    tracePropagationTargets: [
      new RegExp(API_URL ?? "localhost"),
    ],
  });

  console.info("Sentry initialized for tenant-ai-widget");
}
else {
  console.info("Sentry not enabled or DSN missing (or not production)");
}

export { Sentry };
